import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import Select from "react-select";
import { axiosInstance } from "../../utils/networking";
import ThriveTitle from "../common/ThriveTitle";

const Add2ndBfc = (props: any) => {
  const navigate = useNavigate();

  const [clientList, setClientList] = useState<
    { _id: any; firstName: string; lastName: string; email: string }[]
  >([]);
  const [selectedValue, setSelectedValue] = useState<{
    value: any;
    label: any;
  }>({
    value: props.currUser._id,
    label: props.currUser.firstName + " " + props.currUser.lastName,
  });

  useEffect(() => {
    axiosInstance.get(`/user/allUsers`).then((res) => {
      if (res.status === 200) {
        setClientList(res.data.users);
      } else {
        console.log("API Error at getting survey result");
      }
    });
  }, []);

  const handleSelectChange = (selectedClient: any) => {
    setSelectedValue(selectedClient);
  };

  const handleSubmit = () => {
    axiosInstance
      .post(`/cases/addbfc`, {
        caseId: props.caseId,
        userId: selectedValue.value,
      })
      .then((res) => {
        props.setAddBfcOpen(false);
        window.location.reload();
      });
  };

  return (
    <>
      <ThriveTitle title={"ADD SECONDARY SBC"} setOpen={props.setAddBfcOpen} />
      <div className="w-full h-full flex flex-col items-center px-4 sm:px-0">
        <div className="mt-[20%] w-full max-w-[400px]">
          <Select
            value={selectedValue}
            onChange={handleSelectChange}
            className="w-full max-w-[400px]"
            placeholder="Select the Client"
            options={clientList.map((client) => ({
              value: client._id,
              label: client.firstName + " " + client.lastName,
            }))}
            styles={{
              control: (provided, state) => ({
                ...provided,
                height: "50px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#9D2362" : "white",
                color: state.isSelected ? "white" : "black",
                ":hover": {
                  backgroundColor: state.isSelected ? "#9D2362" : "#F3F4F6",
                },
              }),
            }}
          />
        </div>
        <div className="mt-3">
          <Button
            variant="contained"
            sx={{
              width: "200px",
              fontSize: "20px",
              backgroundColor: "#9E1F63FF",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};
export default Add2ndBfc;
